/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import {
    array, bool, func, object,
} from 'prop-types';

import GraphqlProductListAdCategoryContainer from '../GraphqlProductListAddCategroy/GraphqlProductListAdCategoryContainer';
import { getBrand } from '../../../../../pages/Account/state/ducks/Common/Common-Selectors';
import noop from '../../../../../helpers/noop';
import { getPresentationFamily } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import RecommendationsBuilder from '../StandardProductsPage/RecommendationsBuilder';
import RenderWhenVisible from '../../../../../helpers/componentVisibility/RenderWhenVisible';

const useStyles = makeStyles((theme) => ({
    contentBottom: {
        width: '100%',
        margin: '0 auto 60px auto',
        maxWidth: '1380px',
        // Tablet
        [theme.breakpoints.down('md')]: {
            padding: '0 20px 0',
        },
        // Mobile
        [theme.breakpoints.down('sm')]: {
            margin: '0 0 15px 0',
            padding: '0',
        },
    },
    contentBottomDivider: {
        margin: '0 0 15px 0',
        textAlign: 'center',
        width: '100%',
        '&--title': {
            margin: '0',
            textAlign: 'center',
            fontSize: '16px',
            fontWeight: '600',
        },
    },
    plaContentBottom: {
        '@media screen and (min-width:600px)': {
            marginBottom: '0px',
        },
        '& $contentBottomDivider': {
            margin: '28px 0px 16px',
            '@media screen and (min-width:600px)': {
                margin: '32px 0px 28px',
            },
            '&--title': {
                fontSize: '28px',
                lineHeight: '36px',
                textTransform: 'lowercase',
                padding: '0px 0px 1px 16px !important',
                '@media screen and (max-width:1024px)': {
                    fontSize: '20px',
                    lineHeight: '30px',
                },
                '&:first-letter': {
                    textTransform: 'capitalize',
                },
            },
        },
        '& a': {
            '& span': {
                fontSize: '14px !important',
                lineHeight: '19px !important',
            },
        },
        '& .MuiGrid-container ': {
            margin: '0 auto',
        },
        '& .MuiGrid-item': {
            margin: '0px',
        },
    },
    plaFoodContentBottom: {
        '& $contentBottomDivider': {
            '&--title': {
                textAlign: 'left !important',
                fontSize: '26px',
                lineHeight: '36px',
                '@media screen and (max-width:1024px)': {
                    fontSize: '20px',
                    lineHeight: '30px',
                },
            },
        },
    },
}));

export default function PLARecsABWrapper({
    isPlaEnabled, urlParams, trackEvent: trackEventProp, product, skuData, isPlaRedesignEnabled, recommendations, featureFlags,
}) {
    const filterData = {
        lowToHighBtn: '',
        highToLowBtn: '',
        sellingBtn: '',
        giftBox: '',
        localFlorist: '',
    };
    const plaChecks = isPlaEnabled && urlParams;
    const param = urlParams && Object.keys(urlParams).includes('?recommended_product') ? '?recommended_product' : 'recommended_product';
    const recommendedProductChecks = urlParams?.[param];
    const presentationFamily = useSelector(getPresentationFamily);
    const classes = useStyles();
    const brand = useSelector(getBrand);
    const customerBoughtClass = presentationFamily === 'flower' ? classes.plaContentBottom : `${classes.plaContentBottom} ${classes.plaFoodContentBottom}`;

    const renderFallback = () => {
        if (plaChecks || recommendedProductChecks) {
            return (
                <RenderWhenVisible>
                    <div className={`${isPlaRedesignEnabled && customerBoughtClass} ${classes.contentBottom}`}>
                        <div className={classes.contentBottomDivider}>
                            <p className={`${classes.contentBottomDivider}--title`}>Customers Also Bought</p>
                        </div>
                        <GraphqlProductListAdCategoryContainer filterData={filterData} trackEvent={trackEventProp} urlParams={urlParams} brand={brand} PLARecommendations product={product} />
                    </div>
                </RenderWhenVisible>
            );
        }
        return null;
    };

    const isPlaRecsEnabled = featureFlags['is-pla-sf-recs-enabled-pwa'];

    if (isPlaRecsEnabled) {
        if (recommendations?.length > 0) {
            return (
                <RenderWhenVisible>
                    <RecommendationsBuilder
                        featureFlags={featureFlags}
                        product={product}
                        recommendations={recommendations}
                        sortedData={skuData}
                        isPlaRedesignEnabled={isPlaRedesignEnabled}
                        isFromPLAWrapper
                    />
                </RenderWhenVisible>
            );
        }
        return null;
    }

    return renderFallback();
}

PLARecsABWrapper.propTypes = {
    isPlaEnabled: bool,
    urlParams: object,
    trackEvent: func,
    product: object.isRequired,
    skuData: array.isRequired,
    isPlaRedesignEnabled: bool.isRequired,
    recommendations: array,
    featureFlags: object,
};

PLARecsABWrapper.defaultProps = {
    isPlaEnabled: false,
    urlParams: {},
    trackEvent: noop,
    recommendations: [],
    featureFlags: {},
};
